import {
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    TextField,
} from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import styled from "styled-components";
import * as yup from "yup";
import LoadingAnimation from "../../Components/LottieAnimation/LoadingAnimation";
import { PrimaryButton } from "../../Layouts/ButtonsControlled";
import { FormHeading } from "../../Layouts/Heading";
import { postAllPanels, reset,PanelsSearch } from "../../Redux/PanlesSlice/PanelsSlice";
import { getAllState, resetState } from "../../Redux/StateSlice/stateSlice";
import { closeModal } from '../../Redux/modalSlice';

// const validationSchema = yup.object({
//   title: yup.required("Title is required"),
//   wattage: yup.required("Wattage is required"),
// });

const CreatePanels = () => {
    const dispatch = useDispatch();

    // get all states
    useEffect(() => {
        const getStates = async () => {
            await dispatch(getAllState());
            await dispatch(resetState());
        };
        getStates();
    }, []);

    const { states, isStateSuccess, isStateErorr, isStatesloading } =
        useSelector((state) => state.AllStates);

    //get All States
    const AllStates = states?.data?.states;

    const { isError, isSuccess, isLodaing, massage } = useSelector(
        (state) => state.panels
    );
    const [formSubmit, setFormSubmit] = useState(false);

    const formik = useFormik({
        initialValues: {
            title: "",
            wattage: "",
            description: "",
            price: "",
            state_id: "",
            image_path: "",
            is_default: false,
            dimension: '',
            weight: '',
            frame_color: '',
            sheet_color: '',
            cell_type: '',
        },
        //validationSchema: validationSchema,
        onSubmit: async (values) => {
            setFormSubmit(true);
            await dispatch(postAllPanels(values));
            await dispatch(reset());
        },
    });

    useEffect(() => {
        if (isError) {
            toast.error(massage);
        }

        if (isSuccess && formSubmit) {
            setFormSubmit(false);
            toast.success("new panel add");
            dispatch(closeModal())
        }

    }, [isError, isSuccess, massage]);

    return (
        <>
            {isStatesloading && <LoadingAnimation />}
            {!isStatesloading && (
                <FormContainer>
                    <FormHeading>Add a New Panel </FormHeading>
                    <form onSubmit={formik.handleSubmit}>
                        <Grid container columns={12} spacing={3}>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="title"
                                    name="title"
                                    label="Title"
                                    value={formik.values.title}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.title &&
                                        Boolean(formik.errors.title)
                                    }
                                    helperText={
                                        formik.touched.title &&
                                        formik.errors.title
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    type="number"
                                    id="wattage"
                                    name="wattage"
                                    label="Wattage"
                                    value={formik.values.wattage}
                                    onChange={formik.handleChange}
                                    error={
                                        formik.touched.wattage &&
                                        Boolean(formik.errors.wattage)
                                    }
                                    helperText={
                                        formik.touched.wattage &&
                                        formik.errors.wattage
                                    }
                                />
                            </Grid>

                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="description"
                                    name="description"
                                    label="description"
                                    value={formik.values.description}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="price"
                                    name="price"
                                    label="Price"
                                    value={formik.values.Price}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <TextField
                                    fullWidth
                                    id="weight"
                                    name="weight"
                                    label="Weight"
                                    type="number"
                                    value={formik.values.Weight}
                                    onChange={formik.handleChange}
                                />
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth required={true}>
                                    <InputLabel id="demo-simple-select-label">
                                        State
                                    </InputLabel>
                                    <Select
                                        id="state_id"
                                        name="state_id"
                                        label="State"
                                        required={true}
                                        value={formik.values.state_id}
                                        onChange={formik.handleChange}
                                    >
                                        {AllStates?.map((key) => (
                                            <MenuItem
                                                key={key.id}
                                                value={key.id}
                                            >
                                                {key.name}
                                            </MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">
                                    Dimension
                                    </InputLabel>
                                    <Select
                                        id="dimension"
                                        name="dimension"
                                        label="Dimension"
                                        
                                        value={formik.values.dimension}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="length"
                                        >length
                                        </MenuItem>
                                        <MenuItem
                                        value="width"
                                        >width
                                        </MenuItem>
                                        <MenuItem
                                        value="height"
                                        >height
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">
                                    Frame Color
                                    </InputLabel>
                                    <Select
                                        id="frame_color"
                                        name="frame_color"
                                        label="Frame Color"
                                        
                                        value={formik.values.frame_color}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="blue"
                                        >blue
                                        </MenuItem>
                                        <MenuItem
                                        value="silver"
                                        >silver
                                        </MenuItem>
                                        <MenuItem
                                        value="black"
                                        >black
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">
                                        Sheet Color
                                    </InputLabel>
                                    <Select
                                        id="sheet_color"
                                        name="sheet_color"
                                        label="Sheet Color"
                                        
                                        value={formik.values.sheet_color}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="blue"
                                        >blue
                                        </MenuItem>
                                        <MenuItem
                                        value="silver"
                                        >silver
                                        </MenuItem>
                                        <MenuItem
                                        value="black"
                                        >black
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                            <Grid item mb={1} xs={12} md={6}>
                                <FormControl fullWidth >
                                    <InputLabel id="demo-simple-select-label">
                                        Cell Type
                                    </InputLabel>
                                    <Select
                                        id="cell_type"
                                        name="cell_type"
                                        label="Cell Type"
                                        
                                        value={formik.values.cell_type}
                                        onChange={formik.handleChange}
                                    >
                                        <MenuItem
                                        value="monocrystalline"
                                        >monocrystalline
                                        </MenuItem>
                                        <MenuItem
                                        value="polycrystalline"
                                        >polycrystalline
                                        </MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>
                        </Grid>

                        <PrimaryButton fullWidth type="submit">
                            {isLodaing ? "loading..." : "ADD New Panel"}
                        </PrimaryButton>
                    </form>
                </FormContainer>
            )}
        </>
    );
};

const FormContainer = styled.div`
    padding: 1rem;
`;
export default CreatePanels;
